import React from "react";
import { Stack, Button, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

type ScheduleActionButtonsProps = {
  handleSessionAllocations?: () => void;
  handleLiveSessions?: () => void;
  handleSessionUsages?: () => void;
  handleAllocatedSessions?: () => void;
  handleCoHost?: () => void;
  handleObserver?: () => void;
  row?: any;
};

export const ScheduleActionButtons = (props: ScheduleActionButtonsProps) => {
  const {
    handleSessionAllocations,
    handleLiveSessions,
    handleSessionUsages,
    handleAllocatedSessions,
    handleCoHost,
    handleObserver,
    row
  } = props;

  const isActionDisabled = row?.liveSession?.actualStartTime && new Date() > new Date(row?.liveSession?.actualStartTime);

  return (
    <Stack
      direction="column"
      spacing={1}
      alignItems="center"
      sx={{
        whiteSpace: "nowrap",
        overflowX: "auto",
      }}
    >
      <Button
        size="small"
        variant="contained"
        sx={{ textTransform: "none", px: 1, width: 170 }}
        onClick={handleSessionAllocations}
        disabled={isActionDisabled}
      >
        Allocate Session
      </Button>

      <Button
        size="small"
        variant="contained"
        sx={{ textTransform: "none", px: 1, width: 170 }}
        onClick={handleAllocatedSessions}
      >
        View Allocated Sessions
      </Button>

      <Button
        size="small"
        variant="contained"
        sx={{ textTransform: "none", px: 1, width: 170 }}
        onClick={handleLiveSessions}
      >
        View Live Session
      </Button>

      <Button
        size="small"
        variant="contained"
        sx={{ textTransform: "none", px: 1, width: 170 }}
        onClick={handleSessionUsages}
      >
        View Live Session Usages
      </Button>
      <Button
        size="small"
        variant="contained"
        sx={{ textTransform: "none", px: 1, width: 170 }}
        onClick={handleCoHost}
      >
        Co Host
      </Button>
      <Button
        size="small"
        variant="contained"
        sx={{ textTransform: "none", px: 1, width: 170 }}
        onClick={handleObserver}
      >
        Observer
      </Button>
      {/* 
      <IconButton size="small" onClick={handleScheduleCopy}>
        <ContentCopyIcon fontSize="small" sx={{ color: "black" }} />
      </IconButton> */}


    </Stack>
  );
};


type ScheduleCopyAction = {

  handleScheduleCopy?: () => void
};

export const ScheduleCopyAction = (props: ScheduleCopyAction
) => {
  const {
    handleScheduleCopy,
  } = props;

  return (
    <Tooltip title="Copy joining link">
      <IconButton size="small" onClick={handleScheduleCopy}>
        <ContentCopyIcon fontSize="small" sx={{ color: "black" }} />
      </IconButton>
    </Tooltip>
  )

}